import React, {useState, useContext, useEffect, useMemo} from 'react'
import ReactTooltip from 'react-tooltip'
import {Link} from 'react-router-dom'
import {useHistory} from 'react-router-dom'
import DatePicker from 'react-datepicker'
import {formatDate, formatTagFilterDate, checkToday, useDidUpdate} from '../../../utils'
import {FilterContext, ModalContext, CategoryContext, TourContext} from "../../../context/index"
import {fetchLogout} from "../../../api/api"
import Dropdown from '../../Components/Dropdown/Dropdown'
import Input from '../../Components/Input'
import Icons from '../../Components/Icons'
import layout from '../Layout.module.scss'
import css from './Header.module.scss'
import "react-datepicker/dist/react-datepicker.css"


export default function Header() {
	const [sticky, setSticky] = useState(false)
	const {filter, setFilter, resetFilter} = useContext(FilterContext)
	const { tour } = useContext(TourContext)
	const {openModal} = useContext(ModalContext)
	const {categories} = useContext(CategoryContext)
	const history = useHistory()

	const fieldChange = ({name, input}) => {
		setFilter({[name]: input, start_after_id: null})
	}

	const onResetDate = () =>{
		setFilter({fd: new Date(), td: null, start_after_id: null})
	}

	const selectCategory = (item) => {
		const contain = filter.list_ids_arr && filter.list_ids_arr.some(e => e === item.list_id)
		const newFiter = contain ? filter.list_ids_arr.filter(e => e !== item.list_id) : filter.list_ids_arr.concat(item.list_id)

		setFilter({list_ids_arr: newFiter, start_after_id: null})
	}

	const onChange = (dates) => {
		const [start, end] = dates
		setFilter({fd: start, td: end, start_after_id: null})
	}

	const onSubmit = () => {
		history.push({pathname:'/search'})
	}

	const logout = () =>{
		fetchLogout()
	}

	const settings = () => {
		openModal('settings')
	}

	const TopLine = () => {
		return (
			<div className={css.topline}>
				<Link to="/" className={css.logo}>
					<Icons name="logo"/>
				</Link>
				<div className={css.controls}>
					<div className={css.icon} onClick={settings} data-target="settings">
						<Icons name="settings"/>
					</div>
					<div className={css.icon} onClick={logout}>
						<Icons name="logout"/>
					</div>
				</div>
			</div>
		)
	}

	useDidUpdate(() => {
		onSubmit()
	}, [JSON.stringify(filter)])

	useEffect(() => {
		const onScroll = () =>{
			const height = document.getElementById('header').getBoundingClientRect().height
			if (window.scrollY > height + 5 && !sticky) {
				setSticky(true)
			} else if (window.scrollY < height + 5) {
				setSticky(false)
			}
		}

		if(!tour.open){
			ReactTooltip.rebuild()
			window.addEventListener('scroll', onScroll)
		}
		return () => {
			window.removeEventListener('scroll', onScroll)
		}
	},[tour.open])

	return (
		<header id="header" className={css.header + ' ' + (sticky ? css.sticky : '')}>
			<div className={layout.layout}>
				<div className={css.topline}>
					<Link to="/" className={css.logo}>
						<Icons name="logo"/>
					</Link>
					<div className={css.controls}>
						<div className={css.icon} onClick={settings} data-target="settings">
							<Icons name="settings"/>
						</div>
						<div className={css.icon} onClick={logout}>
							<Icons name="logout"/>
						</div>
					</div>
				</div>
				<div className={css.filter} data-target="filters">
					<div className={css.reset} onClick={resetFilter}>Сбросить фильтры</div>
					<form onSubmit={onSubmit} className={css.form}>
						<div className={css.field}>
							<Input
								className={css.input + ' ' +css.text}
								name="q"
								placeholder="Поиск по ключевому слову"
								onChange={fieldChange}
								value={filter.q}/>
						</div>
						<div className={css.field}>
							<Dropdown
								dataTarget={'categories'}
								open={tour.openDropdown}
								header={<><input className={css.input + ' ' + css.read} type="text" placeholder="Выбрать категорию" readOnly value={(categories.length && filter.list_ids_arr.map(i => categories.find(e => e.list_id === i))?.map(e => e?.list_title).join(', ')) || ''} /><i className={css.arrow}/></>}
							>
								<div className={css.dropdown} data-target={'categories-dropdown'}>
									{categories.map(item => {
										const active = filter.list_ids_arr?.some(e => e === item.list_id)

										return(
											<div
												key={item.list_id}
												data-list_id={item.list_id}
												className={css.dropdownItem + ' ' + (active ? css.active : '') + ' ' + (tour.openDropdown ? css.disabled : '')}
												data-tip={item.list_announce}
												data-place="bottom"
												data-class="tooltip"
												data-offset="{'top': 10, 'left': -100}"
												onClick={() => !tour.open ? selectCategory(item) : null}>
												<i/>
												{item.list_title}
											</div>
										)
									})}
								</div>
							</Dropdown>
						</div>
						<div className={css.field + ((formatDate(filter.fd, filter.td).length > 21 && formatDate(filter.fd, filter.td).length < 28) ? ' m-medium' : '') + (formatDate(filter.fd, filter.td).length > 27 ? ' m-small' : '')}>
							<DatePicker
								locale="ru"
								selected={filter.fd}
								onChange={onChange}
								startDate={filter.fd}
								endDate={filter.td}
								popperPlacement="top-start"
								dateFormat="dd MMMM yyyy"
								selectsRange
								shouldCloseOnSelect={false}
								showPopperArrow={false}
								value={formatDate(filter.fd, filter.td)}
							/>
							<i className={css.arrow}/>
						</div>

						<div className={css.field + ' ' + css.submit}>
							<div className={css.btn} onClick={onSubmit}>Поиск</div>
						</div>
					</form>
				</div>
				<div className={css.tagList}>
					{filter.list_ids_arr?.map(e =>{
						const item = categories.find(i => i.list_id === e)

						return item
								? <div
									key={item.list_id}
									className={css.tag}
									>
										{item.list_title}
									<i onClick={() => selectCategory(item)}>
										<Icons name="remove"/>
									</i>
								</div>
								: null
					})}
					<div className={css.tag + ' ' +(checkToday(filter.fd, filter.td) ? css.hideIcon : '')}>
						{formatTagFilterDate(filter.fd, filter.td)}
						<i onClick={() => onResetDate()}>
							<Icons name="remove"/>
						</i>
					</div>
				</div>
			</div>

			{!tour.open
				? <div className={css.fixed}>
					<div className={layout.layout}>
						<div className={css.topline}>
							<Link to="/" className={css.logo}>
								<Icons name="logo"/>
							</Link>
							<div className={css.controls}>
								<div className={css.icon} onClick={settings}>
									<Icons name="settings"/>
								</div>
								<div className={css.icon} onClick={logout}>
									<Icons name="logout"/>
								</div>
							</div>
						</div>
					</div>
				</div>
				: null
			}
		</header>
	);
}